import './RightOrdersPanel.scss';
import { withLoadPanel } from '../../../utils/withLoadPanel';
import { ContactPanelDetails } from './RightOrdersPanelDetails';
const ContactPanelWithLoadPanel = withLoadPanel(ContactPanelDetails);

export const RightOrdersPanel = () => {
  return (
    <ContactPanelWithLoadPanel
      hasData={true}
      panelProps={{        
        position: { of: '.panel' },
        container: '.panel',
      }}
    />
  );
};
